import type { UvInsertsBootstrapPayload } from "models/uv-inserts"
import type { UVInsertConfig } from "../../models/uv-inserts"
import type { SuggestedMessaging } from "../../models/uv-inserts/suggested-messaging"
import type { TemplateIds } from "../../models/uv-inserts/template-ids"
import type { SuggestedMessagingDTO, UVInsertConfigDTO } from "./types"
import { transformRawToSuggestedMessaging } from "./transform-suggested-messaging"
import { transformRawToTemplateIds } from "./transform-template-ids"
import { parseUvInsertConfig } from "./parse-uv-insert-config"

/**
 * Parses Liquid window payload into domain models. All Zod validation runs here (DTO layer).
 */
export function parseBootstrapPayload(options: {
  payload: UvInsertsBootstrapPayload
}): {
  configs: UVInsertConfig[]
  templateIds: TemplateIds
  suggestedMessaging: SuggestedMessaging
} {
  const { payload } = options
  const templateIds = transformRawToTemplateIds({
    dto: payload.templateIds,
  })
  const configs = parseUvInsertConfig({
    dto: { configs: payload.configs as UVInsertConfigDTO[] },
  })
  let suggestedMessaging: SuggestedMessaging = []
  try {
    suggestedMessaging = transformRawToSuggestedMessaging({
      dto: payload.suggestedMessaging as SuggestedMessagingDTO[] | undefined,
    })
  } catch {
    suggestedMessaging = []
  }
  return { configs, templateIds, suggestedMessaging }
}
